import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
export const OfferingInterestType = z.enum(["interest", "requested-meeting"]);
export const clientOfferingInterestUrl = (offeringId, offeringInterest) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/alt-asset/v2/client/offering/${offeringId}/${offeringInterest}`
    : `https://middleware.uat.farther.com/alt-asset/v2/client/offering/${offeringId}/${offeringInterest}`;
export default async function postClientOfferingInterest(offeringId, offeringInterest, config) {
    await axios.post(clientOfferingInterestUrl(offeringId, offeringInterest), undefined, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
}
//# sourceMappingURL=postClientOfferingInterest.js.map